import { render, staticRenderFns } from "./UpdateOrgDetailsModal.vue?vue&type=template&id=470426be&scoped=true"
import script from "./UpdateOrgDetailsModal.vue?vue&type=script&lang=js"
export * from "./UpdateOrgDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrgDetailsModal.vue?vue&type=style&index=0&id=470426be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470426be",
  null
  
)

export default component.exports